"use client";

import {
  Bot,
  ChartColumn,
  Code,
  Download,
  Globe,
  Layers,
  Lock,
  LucideIcon,
  MessageCircleMore,
  MessageSquare,
  Package,
  Rocket,
  Server,
  Shield,
  Sparkles,
  TestTube,
  Users,
  Wrench,
  Zap,
} from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  bot: Bot,
  "chart-column": ChartColumn,
  code: Code,
  download: Download,
  globe: Globe,
  layers: Layers,
  lock: Lock,
  "message-circle-more": MessageCircleMore,
  "message-square": MessageSquare,
  package: Package,
  rocket: Rocket,
  server: Server,
  shield: Shield,
  sparkles: Sparkles,
  "test-tube": TestTube,
  users: Users,
  wrench: Wrench,
  zap: Zap,
};

export default function MarketingIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const Icon = iconMap[name] || Sparkles;

  return <Icon className={className} aria-hidden="true" />;
}
